module.exports = __webpack_public_path__ + "assets/img/240b-rw.svg";